import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Stack
} from '@mui/material';

const ProjectForm = ({ initialData = null, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    titleFa: '',
    titleEn: '',
    description: '',
    type: 'trial'
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        titleFa: initialData.title?.fa || '',
        titleEn: initialData.title?.en || '',
        description: initialData.description || '',
        type: initialData.type || 'trial'
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.titleFa.trim()) {
      alert('عنوان فارسی پروژه الزامی است');
      return;
    }

    const finalData = {
      title: {
        fa: formData.titleFa,
        en: formData.titleEn.trim() || formData.titleFa
      },
      description: formData.description,
      type: formData.type
    };

    onSubmit(finalData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }} dir="rtl">
      <Stack spacing={2}>
        <TextField
          label="عنوان پروژه (فارسی)"
          name="titleFa"
          value={formData.titleFa}
          onChange={handleChange}
          fullWidth
          required
        />

        <TextField
          label="عنوان پروژه (انگلیسی)"
          name="titleEn"
          value={formData.titleEn}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="توضیحات"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
        />

        <TextField
          label="نوع پروژه"
          name="type"
          select
          value={formData.type}
          onChange={handleChange}
          fullWidth
        >
          <MenuItem value="trial">آزمایشی</MenuItem>
          <MenuItem value="main">اصلی</MenuItem>
        </TextField>

        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button onClick={onCancel}>انصراف</Button>
          <Button variant="contained" type="submit">
            {initialData ? 'ویرایش پروژه' : 'ایجاد پروژه'}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ProjectForm;
